import {parseFragment} from "parse5";

// Scene text records also contain legacy plain strings. Only values with
// this prefix are HTML when a former textarea reads the record.
export const RICH_TEXT_PREFIX = "<!--coverbaker:rich-text:v1-->";
const TAIL_ATTRIBUTE = "data-content-editable-tail";

/** Use the same list structure for legacy strings in the editor and API. */
export function contentEditableListHtml(html: string): string {
  if (!html) return "<li></li>";
  if (/<li[\s>]/i.test(html)) return html;
  return html.split("\n").map((line) => `<li>${line.replace(/^[•\-*]\s*/, "")}</li>`).join("");
}

export function isRichEditableText(text: string): boolean {
  return text.startsWith(RICH_TEXT_PREFIX);
}

export function contentEditableHtml(text: string, plain: boolean, caretTail = true): string {
  const html = isRichEditableText(text) ? text.slice(RICH_TEXT_PREFIX.length)
    : plain ? text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : text;
  // A terminal break gives the browser a caret position after a trailing
  // newline. It belongs to the editor, not to the saved scene.
  return plain && caretTail ? `${html}<br ${TAIL_ATTRIBUTE}="">` : html;
}

export function storeContentEditableHtml(html: string, marked: boolean): string {
  let content = html;
  if (html.includes(TAIL_ATTRIBUTE)) {
    const template = document.createElement("template");
    template.innerHTML = html;
    for (const tail of template.content.querySelectorAll(`br[${TAIL_ATTRIBUTE}]`)) tail.remove();
    content = template.innerHTML;
  }
  return marked ? RICH_TEXT_PREFIX + content : content;
}

export function editableTextContent(text: string): string {
  if (!isRichEditableText(text)) return text;
  const nodes = parseFragment(contentEditableHtml(text, false)).childNodes.toReversed();
  const parts: string[] = [];
  while (nodes.length) {
    const node = nodes.pop()!;
    if ("value" in node) parts.push(node.value);
    else if ("tagName" in node && node.tagName === "br") parts.push("\n");
    else if ("childNodes" in node) {
      for (let i = node.childNodes.length - 1; i >= 0; i--) nodes.push(node.childNodes[i]);
    }
  }
  return parts.join("");
}
